import { asyncThunkCreator, buildCreateSlice } from "@reduxjs/toolkit";

export const createAsyncThunkSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});
